const MessageTypes={
    MESSAGE_TO_BE_SHOWN:'MESSAGE_TO_BE_SHOWN',
    SET_SEVERTY:'SET_SEVERTY'
};

export default MessageTypes;